import {PropsWithChildren, useCallback} from 'react';
import {useNavigate} from "react-router-dom";
import {Container} from '@yosmanyga/rich-ui';
import {Map, MapHelp} from '@yosmanyga/fortaleza-core';
import {BlankLayout} from "../BlankLayout.tsx";

const MapScreen = () => {
    const navigate = useNavigate();

    const Layout = useCallback(({basic, children, ...props}: PropsWithChildren<{ basic?: boolean }>) => {
        return <BlankLayout
            templates={{
                help: () => {
                    return <MapHelp
                        templates={{
                            layout: Container,
                        }}
                    />
                }
            }}
            onBack={() => {
                navigate(-1);
            }}
            {...props}
        >
            {children}
        </BlankLayout>
    }, [])

    return <Map
        templates={{
            layout: Layout,
        }}
    />
};

export {MapScreen};
